interface TotalBlockProps {
  platformsRawTotal: number;
  discountRate: number;
  discountAmount: number;
  platformsTotal: number;
  workerTotal: number;
  total: number;
  enabledCount: number;
}

function fmt(value: number): string {
  return value.toFixed(2);
}

export default function TotalBlock({
  platformsRawTotal,
  discountRate,
  platformsTotal,
  workerTotal,
  total,
  enabledCount,
}: TotalBlockProps) {
  const hasDiscount = discountRate > 0 && enabledCount >= 2;

  return (
    <section className="pt-8">
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Площадки</span>
          <div className="flex items-center gap-2">
            {hasDiscount && (
              <span className="text-sm text-gray-300 line-through">
                ${fmt(platformsRawTotal)}/мес
              </span>
            )}
            <span className="text-sm font-medium text-gray-900">
              ${fmt(platformsTotal)}/мес
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Менеджеры</span>
          <span className="text-sm font-medium text-gray-900">
            ${fmt(workerTotal)}/мес
          </span>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-gray-200">
          <span className="text-base font-semibold text-gray-900">Итого</span>
          <span className="text-2xl font-bold text-[#2563EB]">
            ${fmt(total)}/мес
          </span>
        </div>
      </div>

      <p className="mt-4 text-xs text-gray-300 text-right">Валюта — USDT (TRC20)</p>
    </section>
  );
}
